import * as React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import ResumenDocentes from './ResumenDocente';
import ObtieneDatosCookies from '../tools/obtieneDatosCookiesUsuario';
import comprueboPermisos from '../tools/comprueboPermisos';
import ControlPresente from './ControlPresente';

function CargaMasiva({ escuelaSeleccionada }) {
  const Usuario = React.useMemo(() => ObtieneDatosCookies(), []);
  const [data, setData] = useState(null);
  const getFechaArgentina = () => {
    const ahora = new Date();
    // Resta 3 horas (Argentina está en UTC-3)
    ahora.setHours(ahora.getHours() - 3);
    return ahora.toISOString().split('T')[0];
  };
  
  const [fecha, setFecha] = useState(getFechaArgentina);
  const [escuelaSeleccionadas, seteaEscuela] = useState(null);
  const [loading, setLoading] = useState(false);

 const obtengoHuellas = async (fechaSeleccionada) => {
  try {
    setLoading(true);

    const response = await axios.post(
      `${process.env.REACT_APP_BASEURL}docentes/getHuellasPorFecha`,
      { fecha: fechaSeleccionada }
    );

//     console.log("RESPUESTA:", response.data);
    setData(response.data);

  } catch (error) {
    console.error("ERROR STATUS:", error.response?.status);
    console.error("ERROR DATA:", error.response?.data);
    console.error("ERROR COMPLETO:", error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (!Usuario) return;

    if (
      Usuario.destino == 1 ||
      Usuario.destino == 7 ||
      comprueboPermisos(Usuario.funcion, "Lector Huellas Todas")
    ) {
      seteaEscuela(null);
    } else if (
      Usuario.destino == 10 ||
      comprueboPermisos(Usuario.funcion, "Horas Extension")
    ) {
      seteaEscuela("Extension Comunitaria");
    } else if (
      ["15", "19", "28"].includes(Usuario.destino) ||
      comprueboPermisos(Usuario.funcion, "Horas Investigaciones")
    ) {
      seteaEscuela("Escuela de Investigaciones");
    } else if (
      ["14", "18", "27", "34"].includes(Usuario.destino) ||
      comprueboPermisos(Usuario.funcion, "Horas Escuela Especialidades")
    ) {
      seteaEscuela("Escuela de Especialidades");
    } else if (
      ["12", "16", "25"].includes(Usuario.destino) ||
      comprueboPermisos(Usuario.funcion, "Horas Escuela Policia")
    ) {
      seteaEscuela("Escuela de Policia");
    } else if (
      Usuario.destino == 11 ||
      comprueboPermisos(Usuario.funcion, "Horas Distancia")
    ) {
      seteaEscuela("Educacion a Distancia");
    } else if (
      ["13", "17", "26", "56"].includes(Usuario.destino) ||
      comprueboPermisos(Usuario.funcion, "Horas Escuela Superior")
    ) {
      seteaEscuela("Escuela Superior");
    }
  }, [Usuario]);

  useEffect(() => {
    if (fecha && Usuario) {
      obtengoHuellas(fecha);
    }
  }, [fecha]); 

  return (
    <div className="p-4">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-2">
        <label className="text-sm font-semibold">
          Seleccionar fecha:{" "}
          <input
            type="date"
            value={fecha}
            onChange={(e) => setFecha(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1"
          />
        </label>
      </div>

      {loading ? (
        <p className="text-center">Cargando...</p>
      ) : data ? (<>
        
        <ResumenDocentes data={data} escuela={escuelaSeleccionadas} fecha={fecha} />
       {comprueboPermisos(Usuario.funcion, "Veo quien marco")?<ControlPresente fechaPasada={fecha}/>:""} </>
      ) : (
        <p className="text-center">No hay datos disponibles.</p>
      )}
    </div>
  );
}

export default CargaMasiva;
